// src/features/auth/routes/GuestRoute.tsx
import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '../AuthProvider'
import { useIsAdmin } from '../useIsAdmin'
import { FullScreenLoader } from './FullScreenLoader'

// Inverse of ProtectedRoute for the login page: a signed-in admin has no
// business there — send them home. Loader while the answer is undetermined so
// the form doesn't flash before the redirect.
export const GuestRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthorized, isAuthorizeLoading } = useAuth()
  const { isAdmin, isLoading: isAdminLoading } = useIsAdmin()
  if (isAuthorizeLoading || (isAuthorized && isAdminLoading)) return <FullScreenLoader />
  if (isAuthorized && isAdmin) return <Navigate to="/" replace />
  return <>{children}</>
}
